/* src/app/components/orders-blocked-alert/orders-blocked-alert.component.scss */
h1 {
  font-family: "Raleway", sans-serif;
  font-size: 36px;
  color: var(--ion-color-secondary);
  font-weight: 600;
}
p {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  white-space: pre-line;
}
/*# sourceMappingURL=orders-blocked-alert.component-DR2HF7GK.css.map */
